module.exports = __webpack_public_path__ + "img/avatar3.0a8bbf0f.png";